import React, { useEffect, useRef, useState } from 'react';
import NavBar from '../_components/navbar';
import { connect, useDispatch } from "react-redux";
import { termoUsoAction } from '../_actions';
import { withRouter } from '../_helpers/withRouter';
import {
    Breadcrumb, BreadcrumbItem, Card, CardBody, CardHeader,
    Button, ButtonGroup, Container, Row, Col, FormGroup, Label, Input, Form
} from 'reactstrap';
import { uploadFile } from '../_services'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUndo, faCheck } from '@fortawesome/free-solid-svg-icons'
import './styles.css';
import '././styles.css';
import Select from 'react-select';
import Swal from 'sweetalert2';
import JoditEditor from "jodit-react";

const TermoUsoEdit = (props, { placeholder }) => {

    const dispatch = useDispatch();
    const editor = useRef(null);
    const [content, setContent] = useState('');

    const config = {
        readonly: false,
        placeholder: placeholder || 'Escreva o conteúdo do arquivo aqui',
        removeButtons: ['video', 'superscript', 'subscript', 'AboutJodit', 'print']
    }

    useEffect(() => {
        const { match: { params } } = props;
        const { dispatch } = props;

        if (params.id) {
            dispatch(termoUsoAction.getTermoUsoById(params.id, true));

            if (props.termoUso.link) {
                setFile(props.termoUso.link)
            }
        }

    }, []);

    const handleSelectChange = prop => event => {

        var event2 = {
            type: 'select',
            target: {
                value: event.value
            }
        };
        dispatch(termoUsoAction.onChangeProps(prop, event2));

    };

    const setFile = (event) => {
        uploadFile(event.target.files[0])
            .then((response) => {
                setTimeout(function () {

                    var event2 = {
                        type: 'select',
                        target: {
                            value: response.toString()
                        }
                    };
                    dispatch(termoUsoAction.onChangeProps('link', event2))
                }, 1000);

            })
            .catch((err) => {
                console.log(err)
            })
    }

    const handleChange = prop => event => {
        dispatch(termoUsoAction.onChangeProps(prop, event));
    };

    useEffect(() => {
        dispatch(termoUsoAction.onChangePropsConteudoArquivo('conteudo_arquivo', content))
    }, [content]);

    const handleValidation = () => {

        var valid = true;
        var errors = '';

        if (props.termoUso.link === null || props.termoUso.link === '' || props.termoUso.link === 0) {
            valid = false;
            errors += '<li style="float:left;">Informe um arquivo válido!</li><br>';
        }
        if (props.termoUso.sistema === null || props.termoUso.sistema === '' || props.termoUso.sistema === 0) {
            valid = false;
            errors += '<li style="float:left;">Informe um sistema!</li><br>';
        }

        if (!valid) {

            Swal.fire({
                icon: 'warning',
                title: 'Erros de validação',
                showCloseButton: true,
                showConfirmButton: true,
                html: '<div style="font-size: 14px; text-align: left"><ul>' + errors + '</ul></div>'
            });

        }

        return valid;

    };

    const handleSubmit = event => {

        event.preventDefault();
        const { match: { params } } = props;

        if (handleValidation()) {

            let payload = {
                id: params.id,
                link: props.termoUso.link,
                sistema: props.termoUso.sistema,
                conteudo_arquivo: props.termoUso.conteudo_arquivo ? props.termoUso.conteudo_arquivo.replace('<p>', '').replace('</p>', '') : null
            }

            if (params.id) {
                dispatch(termoUsoAction.editTermoUsoInfo(params.id, payload));
            } else {
                dispatch(termoUsoAction.createTermoUso(payload));
            }

        }

    };

    const renderOptionsSistema = () => {
        var tipoData = [
            { value: '', name: 'SELECIONE...' },
            { value: 'financeiro', name: 'Financeiro' },
            { value: 'inseminadores', name: 'Inseminadores' },
            { value: 'zootecnico', name: 'Zootécnico' }
        ];

        return tipoData.map((p, i) => {
            return (
                { value: p.value, label: p.name }
            );
        });
    };

    return (
        <div>
            <NavBar {...props} />
            <Container>
                <Card>
                    <CardHeader>
                        <Row>
                            <Col md={12}>
                                <Breadcrumb>
                                    <BreadcrumbItem><a href="/termosUsos">Lista de Termos de Uso</a></BreadcrumbItem>
                                    <BreadcrumbItem active>Termo de Uso {props.termoUso.id}</BreadcrumbItem>
                                </Breadcrumb>
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody>
                        <Form onSubmit={(event) => handleSubmit(event)}>
                            <Row>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label className="left" for="link">{!props.termoUso.link ? 'Selecionar Arquivo *' : 'Alterar arquivo'}</Label>
                                        <Input
                                            id="link"
                                            label="Arquivo *"
                                            onChange={e => setFile(e)}
                                            type="file"
                                        />
                                        {props.termoUso.link ? <Label className="left" style={{ fontSize: 12, marginTop: 3 }}>Arquivo atual: {props.termoUso.link}</Label> : ''}
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label className="left" for="tipo">Sistema *</Label>
                                        <Select
                                            classNamePrefix="select"
                                            value={renderOptionsSistema().filter(function (option) {
                                                return option.value === (props.termoUso.sistema || '');
                                            })}
                                            placeholder="Selecione..."
                                            onChange={handleSelectChange('sistema')}
                                            isSearchable
                                            id="sistema"
                                            name="sistema"
                                            options={renderOptionsSistema()}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="12" style={{ marginTop: 15 }}>
                                    <FormGroup>
                                        <Label className="left" for="conteudo_arquivo">Conteúdo Arquivo</Label>
                                        <JoditEditor
                                            id="conteudo_arquivo"
                                            ref={editor}
                                            value={props.termoUso.conteudo_arquivo}
                                            config={config}
                                            tabIndex={1}
                                            onBlur={newContent => setContent(newContent)}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <br />
                            <Row>
                                <Col className="left" md="8" lg="6">
                                    <span>* Campos obrigatórios</span>
                                </Col>
                                <Col className="d-flex flex-row-reverse" md="4" lg="6">
                                    <ButtonGroup>
                                        <Button variant="contained" className="mr-1" color="secondary" component='a' href="/termosUsos">Voltar <FontAwesomeIcon icon={faUndo} /></Button>
                                        <Button variant="contained" className="mr-1" color="primary" type="submit">Salvar <FontAwesomeIcon icon={faCheck} /></Button>
                                    </ButtonGroup>
                                </Col>
                            </Row>
                        </Form>
                    </CardBody>
                </Card>
            </Container>

            
        </div>
    );

}

const mapStateToProps = (state) => {
    return state;
}

const connectedTermoUsoEditPage = withRouter(connect(mapStateToProps, null, null, {
    pure: false
})(TermoUsoEdit));
export { connectedTermoUsoEditPage as TermoUsoEdit };